// @flow

import * as React from "react";
import { NavLink, useHistory, withRouter } from "react-router-dom";

import { Site, RouterContextProvider } from "tabler-react";
import logo from "../assets/img/logo1.svg";
import { ROUTES } from "../route";

const navBarItems = [
  {
    value: "Manage User",
    to: ROUTES.DASHBOARD,
    icon: "home",
    LinkComponent: withRouter(NavLink),
    useExact: true,
  },
  {
    value: "Add User",
    to: ROUTES.CREATE_USER,
    icon: "check-square",
    LinkComponent: withRouter(NavLink),
  },
];
const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

const SiteWrapper = ({ children }) => {
  const [name,setName] =React.useState("")
  const history = useHistory();
  const _bootscreen = async () => {
    const token = await localStorage.getItem("token");
    
    if (!token) {
      history.push(ROUTES.LOGIN);
    } else {
      const data = await parseJwt(token);
      setName(data?.name)
    }
  };
  React.useEffect(() => {
    _bootscreen();
  }, []);
  const accountDropdownProps = {
    avatarURL: "./demo/faces/female/25.jpg",
    name:name,
    description: "",
    options: [
      // { icon: "user", value: "Profile" },
      {
        icon: "log-out",
        to: ROUTES.LOGIN,
        onClick: () => {
          logout();
        },
        value: "Sign out",
      },
    ],
  };

  const logout = async () => {
    await localStorage.clear();
    history.push(ROUTES.LOGIN);
  };
  return (
    <Site.Wrapper
      headerProps={{
        alt: "LRN ",
        imageURL: logo,
        
        accountDropdown: accountDropdownProps,
      }}
      navProps={{ itemsObjects: navBarItems }}
      routerContextComponentType={withRouter(RouterContextProvider)}
    >
      {children}
    </Site.Wrapper>
  );
};

export default SiteWrapper;
